import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsCommonModule } from '@modules/components-common';
import { I18nModule } from '@nx-ng/i18n';
import { MaterialModule } from '@nx-ng/material';
import { PageNotFoundRoutingModule } from './error-page.routing.module';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { TechnicalDifficultiesComponent } from './components/technical-difficulties/technical-difficulties.component';
import { PaymentFailurePageComponent } from './components/payment-failure-page/payment-failure-page.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MaterialModule,
    ComponentsCommonModule,
    PageNotFoundRoutingModule,
  ],
  declarations: [
    PageNotFoundComponent,
    TechnicalDifficultiesComponent,
    PaymentFailurePageComponent,
  ],
  exports: [TechnicalDifficultiesComponent],
})
export class ErrorPageModule {}
